/**
 * Creates a string comparator based on the specified selector.
 * @param selector The selector to select a sorting value.
 */
export function compare<T>(selector: (obj: T) => string): (a: T, b: T) => number {
    return (a: T, b: T) =>
        selector(a).localeCompare(selector(b))
}

function compareSimple(a, b): number {
    if(a < b)
        return -1
    if(a > b)
        return 1
    return 0
}

/**
 * Creates a number comparator based on the specified selector.
 * @param selector The selector to select a sorting value.
 */
export function compareNumber<T>(selector: (obj: T) => number): (a: T, b: T) => number {
    return (a: T, b: T) =>
        compareSimple(
            selector(a),
            selector(b))
}

/**
 * Creates a date comparator based on the specified selector.
 * @param selector The selector to select a sorting value.
 */
export function compareDate<T>(selector: (obj: T) => Date): (a: T, b: T) => number {
    return (a: T, b: T) =>
        compareSimple(
            selector(a),
            selector(b))
}

export function mapOrder(array: any[], order: any[], key: string): any[] {
  array.sort((a, b) => {
    let A = a[key]
    let B = b[key]

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1
    } else {
      return -1
    }
  })

  return array
}
